export class PetReferModel {
    pet_no: number
    _refer: string
    set refer(value: string) {
        this._refer = value;
    }
    get refer(): string {
        return `${this.refer_doctor} at ${this.refer_hospital} on ${this.refer_date}`;
    }
    refer_doctor: string
    refer_hospital: string
    refer_date: any
    refer_type: number

    constructor(
        pet_no: number,
        refer_doctor: string,
        refer_hospital: string,
        refer_date: any,
        refer_type: number
    ) {
        this.pet_no = pet_no
        this.refer_doctor = refer_doctor
        this.refer_hospital = refer_hospital
        this.refer_date = refer_date ? refer_date : ''
        this.refer_type = refer_type
    }
}